import { render } from "./FooterComponents.vue?vue&type=template&id=d6397e28&scoped=true"
const script = {}

import "./FooterComponents.vue?vue&type=style&index=0&id=d6397e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6397e28"]])

export default __exports__